const updates = [
  { date: '2026-07-31', title: '91视频本周热门榜单更新，多部高分内容新上榜', tag: '榜单更新' },
  { date: '2026-07-30', title: '97视频平台新增4K超清专区，画质全面升级', tag: '功能升级' },
  { date: '2026-07-29', title: '51视频网站经典回顾专题上线，历年佳作一网打尽', tag: '专题上线' },
  { date: '2026-07-28', title: '数字视频平台独家频道更新，三部原创纪录片首发', tag: '独家内容' },
  { date: '2026-07-27', title: '宅男视频移动端版本更新，新增离线缓存与投屏优化', tag: '版本更新' },
  { date: '2026-07-26', title: '91在线视频暑期特别企划启动，每日精选限时免费', tag: '活动预告' },
  { date: '2026-07-25', title: '平台播放流畅度再提升，CDN节点扩容覆盖更多地区', tag: '技术升级' },
  { date: '2026-07-24', title: '97视频创作者扶持计划第二期名单公布', tag: '社区动态' },
  { date: '2026-07-23', title: '宅男视频社区互动功能上线，支持弹幕与评论互动', tag: '新功能' },
];

const ranking = [
  { rank: 1, title: '91视频年度精选TOP10合集', views: '128.6万', change: 'up', tag: '91视频' },
  { rank: 2, title: '97视频最新上线热门内容速递', views: '96.3万', change: 'up', tag: '97视频' },
  { rank: 3, title: '51视频网站经典回顾：银幕记忆', views: '87.1万', change: 'same', tag: '51视频' },
  { rank: 4, title: '数字视频平台独家幕后花絮特辑', views: '72.5万', change: 'up', tag: '数字平台' },
  { rank: 5, title: '宅男视频社区精选：观众票选佳作', views: '65.8万', change: 'down', tag: '社区' },
  { rank: 6, title: '4K超清体验专区 · 视觉盛宴', views: '58.2万', change: 'up', tag: '高清' },
];

export function SectionUpdates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            最新动态
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            宅男视频平台最新更新、专题上线与功能升级一览
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative">
            <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-background-200"></div>
            <div className="space-y-0">
              {updates.map((item, idx) => (
                <div key={idx} className="relative flex items-start gap-4 md:gap-6 pb-6 md:pb-8 last:pb-0">
                  <div className="relative z-10 flex-shrink-0 w-8 md:w-12 flex justify-center">
                    <div className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-primary-500 mt-2"></div>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex flex-wrap items-center gap-2 mb-1.5">
                      <span className="text-xs md:text-sm font-medium text-foreground-400 whitespace-nowrap">
                        {item.date}
                      </span>
                      <span className="inline-block px-2 py-0.5 rounded-full text-xs font-medium bg-accent-100 text-accent-800 whitespace-nowrap">
                        {item.tag}
                      </span>
                    </div>
                    <p className="text-sm md:text-base text-foreground-800 font-medium leading-relaxed">
                      {item.title}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function SectionRanking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热门榜单
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            宅男视频实时热门内容排行，看看大家都在看什么
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="rounded-lg overflow-hidden border border-background-200/70 bg-background-50">
            {ranking.map((item, idx) => (
              <div
                key={item.rank}
                className={`flex items-center gap-4 px-4 md:px-6 py-4 cursor-pointer hover:bg-background-100 transition-colors duration-200 ${
                  idx < ranking.length - 1 ? 'border-b border-background-200/50' : ''
                }`}
              >
                <div className="flex-shrink-0 w-8 md:w-10 text-center">
                  {item.rank <= 3 ? (
                    <span className={`inline-flex items-center justify-center w-7 h-7 md:w-8 md:h-8 rounded-md text-sm font-bold text-background-50 ${
                      item.rank === 1 ? 'bg-primary-500' : item.rank === 2 ? 'bg-accent-500' : 'bg-secondary-500'
                    }`}>
                      {item.rank}
                    </span>
                  ) : (
                    <span className="text-sm font-bold text-foreground-400">{item.rank}</span>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm md:text-base font-medium text-foreground-900 truncate">
                    {item.title}
                  </p>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="inline-block px-1.5 py-0.5 rounded text-xs bg-secondary-100 text-secondary-700 whitespace-nowrap">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.views} 次观看</span>
                  </div>
                </div>
                <div className="flex-shrink-0 flex items-center gap-2">
                  {item.change === 'up' && (
                    <i className="ri-arrow-up-line text-primary-500 text-sm"></i>
                  )}
                  {item.change === 'down' && (
                    <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>
                  )}
                  {item.change === 'same' && (
                    <i className="ri-subtract-line text-foreground-400 text-sm"></i>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}